import { unreadonly } from '../../../types';
import type { ObjectFilterChild, TableFilterBase } from '../TableFilter';
import { filterOperators } from '../operators';

const objectFilterOperators = unreadonly([
  ...filterOperators.empty,
  ...filterOperators.color,
] as const);

export type ObjectFilterOperator = (typeof objectFilterOperators)[number];

export type ObjectFilter = TableFilterBase & {
  type: 'object';
  children: ObjectFilterChild[];
};

export const createObjectFilter = (
  children: ObjectFilterChild[],
): ObjectFilter => ({
  type: 'object',
  operators: objectFilterOperators,
  children,
});
